import { FC } from 'react';
import styles from './AppFooter.module.scss';

export const AppFooter: FC = () => {
  const onNotificationClick = () => {
    if (!window.apm) {
      return;
    }

    try {
      window.apm.popup(
        window.l.popup.notification_log,
        window.apm.notification.getView(),
        '<button class="w2ui-btn secondary" onclick="w2popup.close();">'
          + window.l.popup.close
          + '</button>'
      );
    } catch {
      // Footer must remain safe before legacy globals are ready.
    }
  };

  return (
    <div
      id="bottom-notification"
      className={styles.footer}
      onClick={onNotificationClick}
    >
      <div id="bottom-notification-icon">
        <i className="fe icon-info" />
      </div>
      <div id="bottom-notification-text" />
    </div>
  );
};
